$(function() {

    $.profiles = {};

    $('.profile-section').each(function(i) {

        var id = $(this).attr('id');
        var section = '#'+ id;

        $.profiles[id] = {};

        // durations

        $.profiles[id].calculateContentHeight = function() {
            var height = $(section +' .content-container').outerHeight();
            return height;
        };
    
        $.profiles[id].calculateBackgroundPin = function() {
            var height = $(window).innerHeight();
            var contentHeight = $.profiles[id].calculateContentHeight();
            var pin = height + contentHeight + (height / 2);
            return pin;
        };

        $.profiles[id].duration = '50%';
        
        $.profiles[id].tl = {};

        // in

        $.profiles[id].tl.in = new TimelineMax();

        $.profiles[id].tl.in.addLabel('start');
        $.profiles[id].tl.in.addLabel('line', 0.75);

        $.profiles[id].nextSectionID = $(section).next('section').attr('id');
        $.profiles[id].tl.in.set('#'+ $.profiles[id].nextSectionID, { visibility: 'visible' }, 'start');

        $.profiles[id].tl.in.from(section +' .profile-svg-container .title-mask', 1, { y : 5120 }, 'start');
        $.profiles[id].tl.in.from(section +' .profile-svg-container .blob-shape', 1, { y : 5120 }, 'start');
        $.profiles[id].tl.in.fromTo(section +' .profile-svg-container .blob-shape', 0.25, { drawSVG : '0 0' }, { drawSVG : '0 100%' }, 'line');

        new ScrollMagic.Scene({ triggerElement: section +' .profile-start', triggerHook: 'onLeave', duration: '100%' })
            .setTween($.profiles[id].tl.in)
            // .addIndicators({name: id +' in'})
            .addTo($.controller);

        new ScrollMagic.Scene({ triggerElement: section +' .profile-pin', triggerHook: 'onLeave', duration: $.profiles[id].calculateBackgroundPin })
            .setPin(section +' .profile-svg-container')
            // .addIndicators({name: id +' pin'})
            .addTo($.controller);

        // content

        $.profiles[id].tl.content = new TimelineMax();

        $.profiles[id].tl.content.addLabel('start');
        $.profiles[id].tl.content.addLabel('content', 0.25);
        $.profiles[id].tl.content.set(section +' .profile-svg-container', { force3D : true }, 'start');
        $.profiles[id].tl.content.set(section +' .profile-svg-container .blob-shape', { transformOrigin : '50% 50%' }, 'start');
        $.profiles[id].tl.content.to(section +' .profile-svg-container .title-filled', 0.25, { opacity : 0 }, 'start');
        $.profiles[id].tl.content.to(section +' .profile-svg-container .background image', 0.25, { opacity : 0 }, 'start');
        $.profiles[id].tl.content.to(section +' .profile-svg-container .blob-shape', 0.25, { fillOpacity : 1 }, 'start');
        $.profiles[id].tl.content.to(section +' .profile-svg-container .background-white', 0.25, { fillOpacity : 1 }, 'start');
        $.profiles[id].tl.content.to(section +' .profile-svg-container', 0.25, { backgroundColor : '#ffffff' }, 'start');
        $.profiles[id].tl.content.to(section +' .profile-svg-container .title-mask', 1, { y : '-1600', force3D : true }, 'start');
        $.profiles[id].tl.content.to(section +' .profile-svg-container .blob-shape', 1, { morphSVG : section +' .profile-blob-expanded' }, 'start');
        $.profiles[id].tl.content.to(section +' .profile-svg-container .blob-shape', 1, { scale : 2 }, 'start');
        $.profiles[id].tl.content.to(section +' .profile-svg-container .title', 0.25, { opacity : 0 }, 'content');

        new ScrollMagic.Scene({ triggerElement: section +' .profile-pin', triggerHook: 'onLeave', duration: '100%' })
            .setTween($.profiles[id].tl.content)
            // .addIndicators({name: id +' content'})
            .addTo($.controller);

    });

});
